import { useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { logout, setActiveMenu } from '../redux/actions';
import { handleAuthError } from '../services/error-handler';
import Store from '../redux/store';
import config from '../constants/config';
import { withRouter } from './router/withRouter';

const { INACTIVE_TIMEOUT } = config;

const IdleTimerLogout = () => {
    const timeout = INACTIVE_TIMEOUT;

    const onIdle = () => {
        console.debug(
            `Logging out - idle timer reached. Idle '${timeout / 1000}' seconds`,
        );
        Store.store.dispatch(setActiveMenu('Dashboard'));
        Store.store.dispatch(logout());
        Store.store.dispatch(handleAuthError());
    };

    const onAction = () => {
        localStorage.setItem('activity', new Date().toISOString());
    };

    const { reset } = useIdleTimer({
        timeout,
        onIdle,
        onAction,
        debounce: 500,
        crossTab: true,
    });

    useEffect(() => {
        const handleStorage = (e) => {
            if (e.key === 'activity') {
                reset(); // Reset on activity from another tab
            }
        };
        window.addEventListener('storage', handleStorage, true);
        return () => {
            window.removeEventListener('storage', handleStorage, true);
        };
    }, [reset]);

    return null;
};

export default withRouter(IdleTimerLogout);
